module.exports = __webpack_public_path__ + "static/media/12UNCTAD10.93a68c76.jpg";